import { CommitClass, GovernanceDecisionValue } from './constants.js';
import { deterministicHash } from './stable.js';
import { hasCompleteSatisfiedPredicateVector } from './predicates.js';

const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;

export function transitionValidationErrors(record, { expectedPreviousHash } = {}) {
  const errors = [];
  if (!isNonEmptyString(record?.transitionRecordId)) errors.push('TRANSITION_ID_REQUIRED');
  if (record?.priorCommitClass !== CommitClass.ASSOCIATIVE || record?.nextCommitClass !== CommitClass.CANONICAL) errors.push('TRANSITION_DIRECTION_INVALID');
  if (!Array.isArray(record?.eventIds) || record.eventIds.length === 0 || record.eventIds.some((id) => !isNonEmptyString(id))) errors.push('SOURCE_EVENTS_REQUIRED');
  if (!isNonEmptyString(record?.traceId)) errors.push('SOURCE_TRACE_REQUIRED');
  if (!hasCompleteSatisfiedPredicateVector(record?.predicateVector)) errors.push('PREDICATE_VECTOR_INVALID');
  else if (!Number.isInteger(record.predicateVector.independentDimensionCount)
    || !Number.isInteger(record.predicateVector.requiredDimensionCount)
    || record.predicateVector.requiredDimensionCount < 2
    || record.predicateVector.independentDimensionCount < record.predicateVector.requiredDimensionCount) errors.push('PREDICATE_COUNTS_INVALID');
  if (record?.governanceDecision !== GovernanceDecisionValue.ALLOW) errors.push('GOVERNANCE_ALLOW_REQUIRED');
  if (!isNonEmptyString(record?.governanceToken)) errors.push('GOVERNANCE_TOKEN_REQUIRED');
  if (!isNonEmptyString(record?.signer)) errors.push('SIGNER_REQUIRED');
  if (!isNonEmptyString(record?.timestamp)) errors.push('TIMESTAMP_REQUIRED');
  if (!isNonEmptyString(record?.previousRecordHash)) errors.push('PREVIOUS_HASH_REQUIRED');
  else if (record.previousRecordHash !== 'GENESIS' && expectedPreviousHash === undefined) errors.push('PREVIOUS_CHAIN_CONTEXT_REQUIRED');
  else if (expectedPreviousHash !== undefined && record.previousRecordHash !== expectedPreviousHash) errors.push('PREVIOUS_HASH_INVALID');
  if (!isNonEmptyString(record?.recordHash)) errors.push('RECORD_HASH_REQUIRED');
  else {
    const { recordHash, ...body } = record;
    if (recordHash !== deterministicHash(body)) errors.push('RECORD_HASH_INVALID');
  }
  return errors;
}

export function appendTransition(log, input) {
  const previousRecordHash = log.at(-1)?.recordHash || 'GENESIS';
  const body = Object.freeze({
    transitionRecordId: input.transitionRecordId, priorCommitClass: CommitClass.ASSOCIATIVE,
    nextCommitClass: CommitClass.CANONICAL, eventIds: Object.freeze([...input.eventIds]), traceId: input.traceId,
    predicateVector: Object.freeze({ ...input.predicateVector }), governanceToken: input.governanceToken,
    governanceDecision: input.governanceDecision, signer: input.signer, timestamp: input.timestamp, previousRecordHash
  });
  const record = Object.freeze({ ...body, recordHash: deterministicHash(body) });
  const errors = transitionValidationErrors(record, { expectedPreviousHash: previousRecordHash });
  if (errors.length) throw new Error(`TRANSITION_INVALID: ${errors.join(',')}`);
  return Object.freeze([...log, record]);
}

export function validateTransition(record, options) { return transitionValidationErrors(record, options).length === 0; }
